import type {CertificateTemplate} from 'organization/Event/Certification/Builder/templates'
import en from 'i18n/messages/en.json'

const bundle = en as Record<string, string>

function pick(key: string): string {
  return bundle[key] || key
}

/** English defaults from the `en` bundle (used for `TEMPLATES` static data). */
export const CERTIFICATE_FIELDS_FALLBACK_EN: CertificateTemplate['fields'] = {
  title: pick('orgCert.defaultCert.title'),
  subtitle: pick('orgCert.defaultCert.subtitle'),
  recipientName: '{{Име}} {{Фамилия}}',
  description: pick('orgCert.defaultCert.description'),
  issuer: pick('orgCert.defaultCert.issuer'),
  date: pick('orgCert.defaultCert.dateLine'),
}

export function getCertificateDefaultFields(
  t: (key: string) => string,
): CertificateTemplate['fields'] {
  return {
    title: t('orgCert.defaultCert.title'),
    subtitle: t('orgCert.defaultCert.subtitle'),
    recipientName: '{{Име}} {{Фамилия}}',
    description: t('orgCert.defaultCert.description'),
    issuer: t('orgCert.defaultCert.issuer'),
    date: t('orgCert.defaultCert.dateLine'),
  }
}
